import * as React from 'react';
import styled from '@emotion/styled';
import { Font } from '../../fonts';

export interface DesktopSectionWidgetProps {
  label: string;
}

export const DesktopSectionWidget: React.FC<React.PropsWithChildren<DesktopSectionWidgetProps>> = (props) => {
  return (
    <S.Container>
      <S.Label>{props.label}</S.Label>
      {props.children}
    </S.Container>
  );
};
namespace S {
  export const Container = styled.div`
    border: solid 1px ${(p) => p.theme.layout.border};
    border-radius: 3px;
    padding: 10px;
  `;

  export const Label = styled.div`
    margin-bottom: 10px;
    color: ${(p) => p.theme.text.primary};
    font-family: ${Font.Special};
    font-size: 18px;
  `;
}
